// Registers static images referenced by server views (via image_pack_url / ViteImageCompatHelper)
// so Vite emits them into the manifest. Bare `import "x.png"` side-effect imports get tree-shaken by
// Rollup; binding each import and exporting it keeps them (their URLs are "used").
import blank from "images/pixel_art/avatars/blank.png"
import example from "images/pixel_art/avatars/example.png"
import duolingoIcon from "images/app/addons/duolingo/icon.svg"
import community from "images/pixel_art/avatars/community.png"
import deepForest from "images/love_irish/adventure/backgrounds/deep_forest.png"
import cave from "images/love_irish/adventure/backgrounds/cave.png"
import landscapeCaliforniaMtDiablo from "images/profile_banners/landscape_california_mt_diablo.png"
import stPatricks2025 from "images/profile_banners/st-patricks-day-2025@2x.png"
import marsh from "images/profile_banners/marsh@2x.png"
import cat1SpriteIdle16 from "images/love_irish/adventure/characters/cat_1/sprite_idle_16.png"
import obeliskLightning from "images/love_irish/adventure/objects/obelisk/lightning_no_letter.png"
import pixieSprite from "design_system/adventure/codex/characters/pixie/sprite.png"

const staticAssets = [
  blank,
  example,
  duolingoIcon,
  community,
  deepForest,
  cave,
  landscapeCaliforniaMtDiablo,
  stPatricks2025,
  marsh,
  cat1SpriteIdle16,
  obeliskLightning,
  pixieSprite,
]

// Side effect so Rollup keeps this module (imported for its side effect in the entrypoint) and its
// asset imports — otherwise the URLs are unused and get tree-shaken out of the manifest.
if (typeof window !== "undefined") {
  window.__loveIrishStaticAssets = staticAssets
}

export default staticAssets
